import {Injectable} from "@angular/core";
import {GenericService} from "../../shared/services/generic.service";
import {DailyTransactionsSummary, GenericChart, RetailerPayoutSummary, TransactionSummary} from "./accounts.model";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {CurrentContextService} from "../../core/services/security/current-context.service";

@Injectable({
  providedIn: 'root'
})
export class AccountsService extends GenericService<DailyTransactionsSummary> {

  constructor(http: HttpClient, private currentContext: CurrentContextService) {
    super(http, environment.apiTransactHost + `/api/offering/district/retailer`);
  }

  getTransactionSchedule(params?: {name: string, val: any}[]): Observable<TransactionSummary[]> {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<TransactionSummary[]>(this.getBaseUrl + `/transactions/schedule`, {params: requestParams})
  }

  getDailyTransactionChartData(params?: {name: string, val: any}[]): Observable<GenericChart> {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<GenericChart>(this.getBaseUrl + `/transactions/summary/chart`, {params: requestParams})
  }

  getAllForDateRange(params?: { name: string, val: any }[]) {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {
        requestParams = requestParams.append(ea.name, ea.val)
      });
    }
    return this.http.get<DailyTransactionsSummary[]>(this.getBaseUrl + `/transactions/summary`, {params: requestParams})
  }

  getPayoutHistoryForDateRange(params: { name: string; val: any }[]): Observable<RetailerPayoutSummary[]> {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {
        requestParams = requestParams.append(ea.name, ea.val)
      });
    }
    return this.http.get<RetailerPayoutSummary[]>(this.getBaseUrl + `/payouts/summary`, {params: requestParams})

  }

  get getBaseUrl(): string {
    const retailerId = this.currentContext.currentRetailer.id;
    return environment.apiTransactHost + `/api/offering/district/retailer/${retailerId}/accounts`;
  }
}
